// Legacy exports for backwards compatibility
export const iosURL = 'https://apps.apple.com/my/app/supermedic/id6443664230';
export const androidURL = 'https://play.google.com/store/apps/details?id=com.supermedic.supermedic';
export const iosURLFacilities = 'https://apps.apple.com/app/supermedic-facilities/id6443664368';
export const androidURLFacilities = 'https://play.google.com/store/apps/details?id=com.supermedic.facilities';

// New structured URL exports
export const APP_URLS = {
  professional: {
    apple: 'https://apps.apple.com/my/app/supermedic/id6443664230',
    google: 'https://play.google.com/store/apps/details?id=com.supermedic.supermedic',
    huawei: 'https://appgallery.huawei.com/app/C113836335',
    web: 'https://hiresupermedic.com',
  },
  facilities: {
    apple: 'https://apps.apple.com/app/supermedic-facilities/id6443664368',
    google: 'https://play.google.com/store/apps/details?id=com.supermedic.facilities',
    huawei: 'https://appgallery.huawei.com/app/C113836195',
    web: 'https://employer.hiresupermedic.com/',
  },
};
